<template>
  <Header />
  <SideHeader
    v-if="pageType"
    :tabs="pageTabs"
    :class="[
      'fixed z-50 mt-5 transition-all duration-300 ease-in-out',
      showSideHeader ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
    ]"
  />
  <main :class="articleClasses" :data-testid="pageType === 'introduction' ? 'container-intro' : undefined">
    <article
      v-if="pageType === 'policy'"
      class="flex w-full max-w-[768px] flex-col items-center bg-slate-50 px-5 pb-24"
    >
      <div class="w-full pt-12 lg:pt-20">
        <slot />
      </div>
    </article>

    <article v-else>
      <slot />
    </article>
  </main>
  <Footer />
</template>

<script setup>
import SideHeader from '~/components/SideHeader.vue'
import {ref, computed, onMounted, onUnmounted} from 'vue'

const route = useRoute()
const {t, locale} = useI18n()

const lastScrollPosition = ref(0)
const showSideHeader = ref(true)

/** 현재 페이지 유형을 결정 */
const pageType = computed(() => {
  const path = route.path
  if (path.includes('/policy')) return 'policy'
  if (path.includes('/introduction')) return 'introduction'
  return null
})

const pageTabs = computed(() => {
  // 약관 페이지 탭
  if (pageType.value === 'policy') {
    const baseTabs = [
      {name: t('policy.terms'), path: '/policy/terms'},
      {name: t('policy.privacy'), path: '/policy/privacy'}
    ]
    if (locale.value !== 'en') {
      baseTabs.push({name: t('policy.location'), path: '/policy/location'})
    }
    return baseTabs
  }

  // 소개 페이지 탭
  if (pageType.value === 'introduction') {
    return [
      {name: t('intro.header.text1'), path: '/introduction/guardiann'},
      {name: t('intro.header.text2'), path: '/introduction/perq'},
      {name: t('intro.header.text3'), path: '/introduction/drRodin'}
    ]
  }

  return []
})

/** 페이지 유형에 따른 컨테이너 클래스 설정 */
const articleClasses = computed(() => {
  if (pageType.value === 'policy') {
    return 'inline-flex w-full flex-col items-center bg-slate-100'
  }
  return ''
})

/** 스크롤 방향과 위치에 따라 사이드 헤더 표시 여부 결정 */
const handleScroll = () => {
  const currentScrollPosition = window.scrollY || document.documentElement.scrollTop
  if (Math.abs(currentScrollPosition - lastScrollPosition.value) < 50) return
  // 상단 근처이거나 위로 스크롤시 사이드 헤더 표시
  showSideHeader.value = currentScrollPosition < 100 || currentScrollPosition < lastScrollPosition.value
  // 현재 위치 저장
  lastScrollPosition.value = currentScrollPosition
}

onMounted(() => window.addEventListener('scroll', handleScroll, {passive: true}))
onUnmounted(() => window.removeEventListener('scroll', handleScroll))
</script>
